// __MICRO_APP_ENVIRONMENT__和__MICRO_APP_PUBLIC_PATH__是由micro-app注入的全局变量
// eslint-disable-next-line no-underscore-dangle
if (window.__MICRO_APP_ENVIRONMENT__) {
  // eslint-disable-next-line
  __webpack_public_path__ = process.env.VUE_APP_DYNAMIC_PUBLIC_PATH || window.__MICRO_APP_PUBLIC_PATH__;
}
